/* tslint:disable */

/**
 */
export class PlotPoints {
    temperature?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/plot-points.ts